import { MouseEvent, useCallback } from 'react';

import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase from 'src/components/GridCellBase';
import useRedirect from 'src/hooks/useRedirect';

const useRedirectBtn = (invoice: boolean, isNewTab = true) => {
  const RedirectButton = (props: GridCellProps) => {
    const { getUrl, redirect } = useRedirect();
    const field = props.field || '';
    const value = props.dataItem[field];
    const id = props.dataItem.receiptId;

    const handleClick = useCallback(
      (e: MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        const url = invoice
          ? getUrl('invoiceDetails')(id, props.dataItem.poId)
          : getUrl('receiptDetails')(id, props.dataItem.poId);
        redirect(url, false, isNewTab);
      },
      [getUrl, id, props.dataItem.poId, redirect]
    );

    return (
      <GridCellBase {...props} rowSelectionEnabled title={value}>
        <button onClick={handleClick} className="text-link cursor-pointer underline">
          {value}
        </button>
      </GridCellBase>
    );
  };

  return RedirectButton;
};

export default useRedirectBtn;
